import { Component } from "@angular/core";
import { AuthService } from "../../../auth-module/services";

@Component({
  selector: "app-settings-menu",
  templateUrl: "./settings-menu.component.html",
  styleUrls: ["./settings-menu.component.scss"]
})
export class SettingsMenuComponent {
  buttons = [
    {
      link: "/settings/dealer",
      name: "Dealer"
    },
    {
      link: "/user",
      name: "Users"
    },
    {
      link: "/teams",
      name: "Teams"
    },
    {
      link: "/settings/finance",
      name: "Finance / Lease"
    },
    {
      link: "/settings/lease-residuals",
      name: "Lease Residuals"
    },
    {
      link: "/settings/insurance",
      name: "Insurance Products"
    },
    {
      link: "/settings/incentives",
      name: "Incentives"
    },
    {
      link: "/settings/menu",
      name: "Menu / External Links"
    },
    {
      link: "/settings/form-server",
      name: "Form Server Configurations"
    },
    {
      link: "/settings/archive",
      name: "Archive"
    },
    {
      link: "/settings/bug-reports",
      name: "Bug Reports"
    },
    {
      link: "/settings/import-report",
      name: "Import Report Emails"
    }
  ];

  token!: string;

  constructor(private authService: AuthService) {
    this.authService.selectToken().subscribe(token => this.token = token);
  }

}
